import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";

export const AI_getProjectList = apiBase.createListInstance({
    endpoint: "/project/",
    method: "get",
    reducer: "projectReducer",
    key: "id",
    reduxKey: "ProjectData",
    listPath : "data.project_list",
    action: "GET_PROJECT_LIST",
    onSuccess: (data) => data
});

export const AI_deleteProject = apiBase.createInstance({
    endpoint: "/project",
    method: "delete",
    reducer: "projectReducer",
    reduxKey: "deleteProjectData",
    action: "DELETE_PROJECT",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getProjectList.deleteAction(
            data.deleted_id
        )
    }
});

export const AI_addProject = apiBase.createInstance({
    endpoint: "/project",
    method: "post",
    reducer: "projectReducer",
    reduxKey: "addProjectData",
    action: "ADD_PROJECT",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getProjectList.updateAction(
            data.project
        )
    }
});

export const AI_updateProject = apiBase.createInstance({
    endpoint: "/project/{id}",
    method: "put",
    reducer: "projectReducer",
    reduxKey: "updateProjectData",
    action: "UPDATE_PROJECT",
    middleware : notificationMiddleWare,
    listPath:"data.rows",
    onSuccess: (data) => {
        AI_getProjectList.updateAction(
            [
                data.project
            ]
        )
    }
});

export const AI_uploadProjectLogo = apiBase.createInstance({
    endpoint: "/upload-logo",
    method: "post",
    reducer: "projectReducer",
    reduxKey: "uploadProjectLogo",
    action: "UPLOAD_PROJECT_LOGO",
    middleware : notificationMiddleWare,
});



export const AI_getProjectNames = apiBase.createInstance({
    endpoint: "/project-names",
    method: "get",
    key: "id",
    reducer: "projectReducer",
    reduxKey: "getprojectnames",
    listPath : "data.project_list",
    action: "GET_PROJECT_NAMES",
    // listPath:"project_list.rows",
    onSuccess: (data) => data.project_list.rows
});
